import { useLang } from "@/context/LangContext";

const BG = "/marquee/produce_splash.png";

const EditorialMarquee = () => {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative py-16 md:py-24 lg:py-32 border-y border-[#E5DFCE] overflow-hidden isolate bg-[#FAF7F0]"
    >
      <img
        src={BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover -z-10"
        draggable="false"
      />
      {/* Softening overlay for text legibility */}
      <div className="absolute inset-0 -z-10 bg-[#FAF7F0]/45" />

      <div className="relative flex items-center justify-center px-6 md:px-10 text-center">
        <span
          className="font-black text-[#0A1F17] text-[6vw] sm:text-[4.4vw] md:text-[3.2vw] lg:text-[2.6vw] leading-tight tracking-tight drop-shadow-[0_2px_8px_rgba(255,255,255,0.6)]"
          style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
        >
          {text}
        </span>
      </div>
    </section>
  );
};

export default EditorialMarquee;
